// extracted by mini-css-extract-plugin
export default {"root":"Overlay_root__iCX7i","hidden":"Overlay_hidden__3J0z0"};